"use strict";
exports.__esModule = true;
exports.isIntersection = exports.isUnion = void 0;
/**
 * Check if a value is a union of two types.
 *
 * @public
 */
var isUnion = function (ptt, ptu) {
    return function (o) {
        return ptt(o) || ptu(o);
    };
};
exports.isUnion = isUnion;
/**
 * Check if a value is an intersection of two types.
 *
 * @public
 */
var isIntersection = function (ptt, ptu) {
    return function (o) {
        return ptt(o) && ptu(o);
    };
};
exports.isIntersection = isIntersection;
//# sourceMappingURL=functions.js.map